import React from "react";
import logger from "logger";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Skeleton from "@material-ui/lab/Skeleton";
import { withRouter, useHistory } from "react-router-dom";
import { loadData } from "AccountDetail";
import { useSelector } from "react-redux";
import UserDataService from "service/UserDataService";
import AddServerDialog from "./AddServerDialog";
import { showDialog } from "DialogProvider";
import PublicOutlinedIcon from "@material-ui/icons/PublicOutlined";
import Button from "@material-ui/core/Button";
import PaypalButton from "./PaypalButton";
import ActionButton from "./ActionButton";
import ValidityCounter from "./ValidityCounter";

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#FBCFD0",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#E7B9C0",
    },
  },
}))(TableRow);

function SMSTableRow(props) {
  const { row, columns } = props;
  const rowId = row.id;
  let history = useHistory();
  const user = useSelector(({ rootScope }) => rootScope.user);

  if (!row) {
    return (
      <StyledTableRow hover role="checkbox" tabIndex={-1} key={rowId}>
        <TableCell colSpan={columns.length}>
          <Skeleton />
          <Skeleton animation={false} />
          <Skeleton animation="wave" />
        </TableCell>
      </StyledTableRow>
    );
  }

  return (
    <StyledTableRow hover role="checkbox" tabIndex={-1} key={rowId}>
      {columns.map((column) => {
        const value = row[column.id];
        if (column.id === "servers") {
          return (
            <TableCell key={column.id} align={column.align}>
              {value.map((server) => (
                <div align="center">
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<PublicOutlinedIcon />}
                    onClick={(event) => {
                      event.preventDefault();
                      loadData(user, server, row, history);
                    }}
                    style={{ margin: "5px" }}
                  >
                    {server}
                  </Button>
                </div>
              ))}
            </TableCell>
          );
        } else if (column.id === "actions") {
          return (
            <TableCell key={column.id} align={column.align}>
              <ActionButton
                addServerOnClick={(e) => {
                  e.preventDefault();
                  showDialog(<AddServerDialog email={row.email} />);
                }}
                removeAccounOnClick={(e) => {
                  e.preventDefault();
                  const result = window.confirm(
                    "Are you sure you want to account?"
                  );
                  if (!result) {
                    return;
                  }
                  UserDataService.removeAccount(row.email);
                }}
              />
            </TableCell>
          );
        } else if (column.id === "accountValidityInSecs") {
          if (value > 0) {
            return (
              <TableCell key={column.id} align={column.align}>
                <ValidityCounter validityRemainingSecs={value} />
              </TableCell>
            );
          } else if (value <= 0) {
            return (
              <TableCell key={column.id} align={column.align}>
                <PaypalButton email={row.email} />
              </TableCell>
            );
          }
        } else if (column.id === "alias_email") {
          return (
            <TableCell key={column.id} align={column.align}>
              <div
                style={{
                  fontWeight: "bold",
                  color: "var(--headingbackgroundcolor)",
                }}
              >
                {value.alias}
              </div>
              <div>{value.email}</div>
            </TableCell>
          );
        } else {
          return (
            <TableCell key={column.id} align={column.align}>
              {column.format && typeof value === "number"
                ? column.format(value)
                : value}
            </TableCell>
          );
        }
      })}
    </StyledTableRow>
  );
}

export default withRouter(SMSTableRow);
